// src/marketing/sampleContent.js
// Hard-coded sample submission + result, shaped exactly like a real evaluation
// response from wc-evaluate. Used only for the public landing page preview —
// no network calls, no Claude API usage.

export const SAMPLE_GRADE_LABEL = "5th Grade";
export const SAMPLE_MODE_LABEL = "Single Paragraph";

export const SAMPLE_TEXT =
  "Recycling is super important for our class and our school and also for the whole world " +
  "and I think we should definitely have a recycling bin in our classroom. First, paper and " +
  "water bottles pile up in our trash can every single day. Second, a recycling bin would " +
  "teach everyone in our class to think about where their trash goes. In conclusion, a " +
  "recycling bin is important for our class.";

export const SAMPLE_RESULT = {
  coachFeedback:
    "You picked a topic you clearly care about, and your supporting sentences give two solid, " +
    "specific reasons! Right now your topic sentence tries to fit a whole argument into one " +
    "breath — splitting it into two sentences will help your big idea land much stronger. Your " +
    "conclusion is a great start, but try ending with why a recycling bin actually matters " +
    "instead of repeating your first sentence.",
  strengths: [
    "Chose a topic sentence with a clear opinion",
    "Used two specific supporting reasons — trash piling up, and teaching the class",
    "Followed a clear topic → support → conclusion order",
  ],
  opportunities: [
    "Break the long topic sentence into two shorter sentences",
    "Add one more concrete detail to the second supporting sentence",
    "Rewrite the conclusion so it doesn't just repeat the topic sentence",
  ],
  annotated: {
    segments: [
      {
        type: "annotated",
        annotationType: "structure",
        text: "Recycling is super important for our class and our school and also for the whole world and I think we should definitely have a recycling bin in our classroom.",
        comment: "Great topic sentence idea, but it's one long run-on sentence — try splitting it into two so your main idea stands out clearly.",
      },
      { type: "original", text: " " },
      {
        type: "annotated",
        annotationType: "strength",
        text: "First, paper and water bottles pile up in our trash can every single day.",
        comment: "Nice, specific detail — this is exactly the kind of evidence a topic sentence needs.",
      },
      { type: "original", text: " " },
      {
        type: "annotated",
        annotationType: "improve",
        text: "Second, a recycling bin would teach everyone in our class to think about where their trash goes.",
        comment: "Good supporting idea — add one more sentence explaining how it would teach them, with a specific example.",
      },
      { type: "original", text: " " },
      {
        type: "annotated",
        annotationType: "style",
        text: "In conclusion, a recycling bin is important for our class.",
        comment: "This restates the topic sentence almost word-for-word. Try ending with why it matters instead.",
      },
    ],
  },
  criteriaRatings: {
    topic_sentence: 3.5,
    supporting_sentences: 4.5,
    conclusion_sentence: 2.5,
  },
  criteriaFeedback: {
    topic_sentence: "Clear opinion, but it's a run-on sentence — split it into two.",
    supporting_sentences: "Two strong, specific reasons. Add one more detail to the second one.",
    conclusion_sentence: "Restates the topic sentence almost exactly — end with why it matters instead.",
  },
};

export const SAMPLE_RUBRIC_SECTION = {
  label: "Paragraph Structure",
  icon: "📝",
  color: "#60a5fa",
  criteria: [
    { key: "topic_sentence", label: "Topic Sentence", desc: "The first sentence clearly states the main idea of the paragraph." },
    { key: "supporting_sentences", label: "Supporting Proof / Sentences", desc: "2+ sentences that develop, explain, or prove the topic sentence with details or evidence." },
    { key: "conclusion_sentence", label: "Conclusion / Clincher", desc: "A closing sentence that wraps up the paragraph's idea without simply repeating the topic sentence." },
  ],
};
